import { Box, LinearProgress, Paper, Typography, styled } from '@mui/material';
import { NavLink } from 'react-router';

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const StyledLimitsContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

export const StyledLimitsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: 'fit-content',
  gap: theme.spacing(0.5),
}));

export const StyledUsedTypography = styled(Typography)({
  color: '#6D77C8',
  fontSize: '18px',
  fontWeight: 700,
});

export const StyledTotalTypography = styled(Typography)({
  color: '#4B5563',
  fontSize: '18px',
  fontWeight: 700,
});

export const StyledTypography = styled(Typography)({
  color: '#4B5563',
  fontSize: '16px',
  display: 'flex',
  alignItems: 'center',
});

export const StyledExpirationInfoTypography = styled(Typography)({
  fontSize: '14px',
  color: '#6B7280',
});

export const StyledLinearProgress = styled(LinearProgress)({
  height: '40px',
  borderRadius: '20px',
  backgroundColor: '#E5E7EB',
  '& .MuiLinearProgress-bar': {
    borderRadius: '20px',
    background: '#6D77C8',
  },
});

export const StyledCreditsBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#F3F4F6',
  borderRadius: theme.spacing(2),
  padding: theme.spacing(3),
  display: 'flex',
  alignItems: 'baseline',
  gap: theme.spacing(1.5),
}));

export const StyledCreditsAmount = styled(Typography)({
  fontSize: '56px',
  fontWeight: 700,
  color: '#1F2937',
  lineHeight: 1,
});

export const StyledCreditsLabel = styled(Typography)({
  fontSize: '20px',
  color: '#9CA3AF',
  fontWeight: 400,
});

export const StyledPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: '#F0F2FFFF',
  border: '1px solid #E0E4FFFF',
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1.5),
  boxShadow: 'none',
}));

export const StyledPaperWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

export const StyledPaperTypography = styled(Typography)({
  fontSize: '14px',
  color: '#4B5563',
});

export const StyledLink = styled(NavLink)({
  fontSize: '14px',
  color: '#1E40AF',
  textDecoration: 'underline',
});
